__turbopack_context__.v({
  "block": "TickerSearch-module-scss-module__C1lRCa__block",
  "search": "TickerSearch-module-scss-module__C1lRCa__search",
});
